import { useState, useEffect } from "react"
import {
    SubmitBtn,
    ActionSection,
    SideCancelBtn,
    ModalHeader,
} from "../Styles/InputStyles"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"
import { toast } from "react-toastify"

const RequestFilter = ({
    onApplyFilter,
    handleClose,
    handleClear,
    selectedType,
    setSelectedType
}) => {
    const [height, setHeight] = useState(window.innerHeight);
    const [activeFilterType, setActiveFilterType] = useState("type");

    const handleTypeChange = (option) => {
        setSelectedType(option);
    }

    const handleApplyFilter = () => {
        if (selectedType) {
            onApplyFilter(
                selectedType?.value || ""
            );
        }
        else {
            toast.error("Please select at least one filter before applying.");
        }
    };

    const handleClearFilters = () => {
        setSelectedType(null);
        handleClear();
    };

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])

    useEffect(() => {
        if (selectedType) {
            setActiveFilterType("type");
        }
    }, [selectedType]);

    const filterGroups = [

        {
            key: "type",
            title: "Type",
        },
    ];

    const typeOptions = [
        { label: "Onboarding", value: 1 },
        { label: "Move Out", value: 2 },
        { label: "Refund", value: 3 },
        { label: "Guest", value: 4 },
    ];

    return (
        <Container style={{ height: `${height}px`, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <ModalHeader>
                <h1 className="text-lg font-medium text-white">Filters</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </ModalHeader>

            <Body>
                <LeftPane>
                    {filterGroups.map((group) => (
                        <TypeItem
                            key={group.key}
                            active={activeFilterType === group.key}
                            onClick={() => setActiveFilterType(group.key)}
                        >
                            {group.title}
                        </TypeItem>
                    ))}
                </LeftPane>

                <RightPane>
                    {activeFilterType === "type" && (
                        <>
                            <FilterTitle>Select Type</FilterTitle>

                            {typeOptions.map((option) => (
                                <OptionRow
                                    key={option.value}
                                    onClick={() => handleTypeChange(option)}
                                    active={selectedType?.value === option.value}
                                >
                                    <input
                                        type="radio"
                                        name="sortBy"
                                        checked={selectedType?.value === option.value}
                                        onChange={() => handleTypeChange(option)}
                                        className="w-4 h-4 text-primary-color focus:ring-primary-color"
                                    />
                                    <span className="flex items-center gap-2 text-sm text-gray-600">
                                        {option.label}
                                    </span>
                                </OptionRow>
                            ))}
                        </>
                    )}
                </RightPane>
            </Body>

            <ActionSection>
                <SideCancelBtn type="button" onClick={handleClearFilters}>
                    Clear
                </SideCancelBtn>
                <SubmitBtn type="submit" onClick={handleApplyFilter}>
                    Apply Filter
                </SubmitBtn>
            </ActionSection>

        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color px-4 py-4`;

const Body = tw.div`flex flex-1 overflow-hidden`;

const LeftPane = tw.div`
  w-1/3 bg-gray-50 border-r overflow-y-auto`;

const TypeItem = tw.div`
  px-4 py-4 cursor-pointer text-md relative
  ${({ active }) =>
        active
            ? "bg-blue-50 text-primary-color font-medium border-l-4 border-primary-color"
            : "text-gray-700 hover:bg-gray-100"}
`;

const RightPane = tw.div`
  flex-1
  py-4
  pl-4
  pr-6
  overflow-y-auto
`;

const OptionRow = tw.div`
  flex items-center gap-3
  py-3 px-2
  cursor-pointer
  text-sm text-gray-400
  rounded-md
  hover:bg-gray-50
  ${({ active }) => active ? "bg-blue-50" : ""}
`;

const FilterTitle = tw.h3`text-md font-medium text-gray-700 mb-2`;

export default RequestFilter;